import React, { Dispatch, FC, SetStateAction } from 'react';
import { Modal, ModalBody, ModalCloseBtn, ModalContent, ModalFooter, ModalHeader } from '@fiverr-private/overlay';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { WorkExperience } from '../../../../gql-operations/gql-generated';
import { CurrentViewState, WorkExperienceViewStates } from '../../shared/types';
import { T_FORM_KEY } from '../../utils';

interface DeleteExperienceModalProps {
    isDeleteModalOpen: boolean;
    setIsDeleteModalOpen: (isDeleteModalOpen: boolean) => void;
    setCurrentViewState: Dispatch<SetStateAction<CurrentViewState>>;
    currentWorkExperiences?: WorkExperience[] | null | undefined;
    setCurrentWorkExperiences: (workExperiences: WorkExperience[] | undefined | null) => void;
    currentExperience?: WorkExperience;
    handleDeleteClick: () => void;
}

const DeleteExperienceModal: FC<DeleteExperienceModalProps> = ({
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    setCurrentViewState,
    setCurrentWorkExperiences,
    currentExperience,
    currentWorkExperiences,
    handleDeleteClick,
}) => {
    const onDeleteClick = () => {
        setIsDeleteModalOpen(false);
        setCurrentViewState({ viewState: WorkExperienceViewStates.List, isDirty: true });
        setCurrentWorkExperiences?.(
            currentWorkExperiences?.filter((experience) => experience.id !== currentExperience?.id)
        );
        handleDeleteClick();
    };

    return (
        <Modal isOpen={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)}>
            <ModalContent>
                <ModalHeader>
                    <I18n k={`${T_FORM_KEY}.delete_modal.title`} />
                    <ModalCloseBtn />
                </ModalHeader>
                <ModalBody>
                    <I18n k={`${T_FORM_KEY}.delete_modal.description`} />
                </ModalBody>
                <ModalFooter>
                    <Button intent="secondary" variant="ghost" onClick={() => setIsDeleteModalOpen(false)}>
                        <I18n k={`${T_FORM_KEY}.delete_modal.cancel`} />
                    </Button>
                    <Button intent="primary" onClick={onDeleteClick}>
                        <I18n k={`${T_FORM_KEY}.delete_modal.delete`} />
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DeleteExperienceModal;
